import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ConfigurationService } from '../Configuration/configuration.service';

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  PageNumber: number = 1
  itemsPerPageDetails: number = 10
  searchTerm: string = ''
  private showLayout: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  showLayout$ = this.showLayout.asObservable();
  customAPIEndPoint: any;
  IPAdress: string = "";
  private sessionTimeOut: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  sessionTimeOut$ = this.sessionTimeOut.asObservable();
  URL: string;
  constructor(private configService: ConfigurationService, private http: HttpClient) {
    this.customAPIEndPoint = this.configService.getCustumAPIEndPoint()
    this.URL = this.configService.getURL()
    //this.getClientIP()
  }
  SetPaginationDetails(PageNumber, itemsPerPageDetails, SearchTerm) {
    this.PageNumber = PageNumber
    this.itemsPerPageDetails = itemsPerPageDetails
    this.searchTerm = SearchTerm
  }
  setShowLayout(layoutVisible: boolean) {
    this.showLayout.next(layoutVisible)
  }
  setSession(data: boolean) {
    this.sessionTimeOut.next(data)
  }
  async getClientIP() {
    const response = await fetch(`${this.customAPIEndPoint}/IPAdress/get-ip-address`)
    const data = await response.json();
    if (!this.isNullOrEmpty(data.IpAddress)) {
      const ipAddresses = data.IpAddress.split(',').map((ip: string) => ip.trim())
      this.IPAdress = ipAddresses[0]?.split(':')[0]
    }
  }
  isNullOrEmpty(value: any) {
    if (value == null) {
      return true
    } else if (value == undefined) {
      return true
    } else if (value.toString() == 'NaN') {
      return true
    } else if (value.toString().trim() == '') {
      return true
    }
    return false
  }
  multiFactorAuth() {
    var Email = localStorage.getItem('UserEmail')
    var UserId = localStorage.getItem('LatestUserLoginID')
    if (Email) {
      Email = Email.toString().toLowerCase()
      return this.http.get<any>(this.URL + "/Authenticate?Email=" + Email + "&UserId=" + UserId).subscribe((data: any) => {
        //if (data.message == "User is Unauthorized.") {
        //  window.location.href = "/MultiFactorAuthentication"
        //}
      })
    }
  }
}
